// supports scroll event
export const scrollEvent = 'onscrollend' in window ? 'scrollend' : 'scroll';
